import { Tooltip } from 'primereact/tooltip';
import { FC } from 'react';
import { splitId } from '../../businessLogicService/splitIdsFromBackEnd';

interface Props {
  data: { studentId: string; currentRoadmapName: string | null };
}

const ProgressTooltip: FC<Props> = ({ data }) => {
  return (
    <>
      <Tooltip
        style={{ borderRadius: '20px' }}
        target={`.exclamation-target-${splitId(data.studentId)}`}
        mouseTrack
        position="bottom"
      >
        <p className="text-0 text-sm p-1" style={{ fontFamily: 'Poppins' }}>
          {`This student is currently on the\n${data.currentRoadmapName} Roadmap,\nwhich is different from the selected filter above.`}
        </p>
      </Tooltip>
    </>
  );
};

export default ProgressTooltip;
